import { isPublicPath } from '@/publicPath';

const root = document.getElementById('root');

if (!root) {
  throw new Error('The Circle could not start: no #root element.');
}

// Two roots, each its own chunk: a public page (status page, client board) never downloads the
// staff app or constructs its sign-in, and the staff app never carries the public pages. `.then`,
// not top-level await, which Vite's default build target rejects.
if (isPublicPath(window.location.pathname)) {
  void import('@/public/PublicRoot').then(({ mountPublic }) => mountPublic(root));
} else {
  void import('@/StaffRoot').then(({ mountStaff }) => mountStaff(root));
}
